import { bsMonthCalculatedData as e, bsMonthMaxDays as t, minBSYear as n } from "../../constants/calendar-date.js";
import { validateBsMonth as r, validateBsYear as i } from "../../utilities/date-validations.js";
// src/design/forms/datepicker/calendar-engine/use-cases/nepali_date/get_number_of_days_in_BS_month.ts
var a = (a) => {
	let { year: o, month: s } = a;
	i(o), r(s);
	let c = 0, l = o + 1 - n;
	return e[s - 1].reduce((e, n, r) => {
		if (n === 0 || e !== 0) return e;
		let i = r % 2;
		return c += n, l > c ? e : o === 2085 && s === 5 || o === 2088 && s === 5 ? t[s - 1][i] - 2 : t[s - 1][i];
	}, 0);
};
export { a as get_number_of_days_in_BS_month };

//# sourceMappingURL=get_number_of_days_in_BS_month.js.map